import React, { useState, useEffect } from 'react';
import { Table, Card, Image, message, Spin, Form, Select, Button, Modal, Input, InputNumber, Popconfirm, Row, Col } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { PlusOutlined, HistoryOutlined, MinusOutlined, CaretDownOutlined, CaretUpOutlined, SearchOutlined } from '@ant-design/icons';
import ResizableTable from '../components/ResizableTable';
import CustomerSelector from '../components/CustomerSelector';

const { Option } = Select;

const Classperiod = ({ user }) => {
  const storedUser = JSON.parse(localStorage.getItem('user')) || {};
  const [customers, setCustomers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null); // 初始值改为 null
  const [selectedClassId, setSelectedClassId] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [currentMember, setCurrentMember] = useState(null);
  const [classTimes, setClassTimes] = useState(1);
  const [historyData, setHistoryData] = useState([]);
  const [isReduce, setIsReduce] = useState(false);
  const { apiClient } = useAuth();

  useEffect(() => {
    // 页面加载时直接查询当前登录用户的数据
    const customerId = storedUser.customerId;
    if (customerId) {
      setSelectedCustomerId(customerId);
      // 自动获取班级列表并查询数据
      fetchClassesByCustomerId(customerId);
    } else {
      // 如果没有存储的customerId，则触发一次查询（可能使用默认行为）
      fetchMembers(1, pagination.pageSize);
    }
  }, []);

  useEffect(() => {
    if (selectedCustomerId) {
      fetchClasses();
    }
  }, [selectedCustomerId]);

  // 监听校区和小队变化，自动查询数据
  useEffect(() => {
    if (selectedCustomerId) {
      fetchMembers(1, pagination.pageSize);
    }
  }, [selectedCustomerId, selectedClassId]);

  // 新增函数：根据customerId获取班级列表
  const fetchClassesByCustomerId = async (customerId) => {
    if (!customerId) {
      setClasses([]);
      return;
    }
    // 先尝试从缓存读取
    try {
      const cached = localStorage.getItem(`classList_${customerId}`);
      if (cached) {
        setClasses(JSON.parse(cached));
        // 在这里也自动触发查询
        fetchMembers(1, pagination.pageSize);
        return;
      }
    } catch (err) {
      console.error('读取班级缓存失败:', err);
    }
    // 缓存没有，调用API
    try {
      const response = await apiClient.post(`/sports-server-prod/api.v1.customer/queryClassList?customerId=${customerId}`);
      if (response.data.code === 200) {
        const list = response.data.data.list || [];
        setClasses(list);
        localStorage.setItem(`classList_${customerId}`, JSON.stringify(list));
        // 自动触发查询
        fetchMembers(1, pagination.pageSize);
      } else {
        message.error('获取班级列表失败');
      }
    } catch (error) {
      console.error('获取班级列表错误:', error);
      message.error('获取班级列表失败');
    }
  };


  const fetchClasses = async () => {
    if (!selectedCustomerId) {
      setClasses([]);
      return;
    }
    // 先尝试从缓存读取
    try {
      const cached = localStorage.getItem(`classList_${selectedCustomerId}`);
      if (cached) {
        setClasses(JSON.parse(cached));
        return;
      }
    } catch (err) {
      console.error('读取班级缓存失败:', err);
    }
    // 缓存没有，调用API
    try {
      const response = await apiClient.post(`/sports-server-prod/api.v1/customer/queryClassList?customerId=${selectedCustomerId}`);
      if (response.data.code === 200) {
        const list = response.data.data.list || [];
        setClasses(list);
        localStorage.setItem(`classList_${selectedCustomerId}`, JSON.stringify(list));
      } else {
        message.error('获取班级列表失败');
      }
    } catch (error) {
      console.error('获取班级列表错误:', error);
      message.error('获取班级列表失败');
    }
  };

  const fetchMembers = async (pageNum = 1, pageSize = 10) => {
    if (!apiClient) return;
    setLoading(true);

    try {
      // 如果没有选择校区，则使用localStorage中的用户customerId
      const customerIdToUse = selectedCustomerId || storedUser.customerId;
      
      if (!customerIdToUse) {
        message.error('请选择校区');
        setLoading(false);
        return;
      }
      
      const params = { customerId: customerIdToUse, pageNum, pageSize };
      if (selectedClassId) {
        params.classId = selectedClassId;
      }
      const response = await apiClient.get('/sports-base-server-prod/myPage/searchInterestClassBaby', {
        params
      });
      if (response.data.result === '1') {
        setMembers(response.data.interestClassBabyList || []);
        setPagination(prev => ({ ...prev, current: pageNum, pageSize, total: response.data.total || 0 }));
      } else {
        message.error('获取会员列表失败');
      }
    } catch (error) {
      console.error('获取会员列表错误:', error);
      message.error('获取会员列表失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchMembers(1, pagination.pageSize);
  };

  const handleAddClassTimes = (record) => {
    setCurrentMember(record);
    setAddModalVisible(true);
  };

  const handleReduceClassTimes = (record) => {
    setCurrentMember(record);
    setIsReduce(true);
    setClassTimes(-1);
    setAddModalVisible(true);
  };

  const handleConfirmAdd = async () => {
    let times = classTimes;
    if (isReduce) {
      if (!times || times >= 0) {
        message.error('请输入负整数课时');
        return;
      }
    } else {
      if (!times || times <= 0) {
        message.error('请输入正整数课时');
        return;
      }
    }
    
    // 检查selectedCustomerId是否已设置
    const customerIdToUse = selectedCustomerId || storedUser.customerId;
    if (!customerIdToUse) {
      message.error('请选择校区');
      return;
    }
    
    try {
      const response = await apiClient.post('/sports-base-server-prod/myPage/updateClassTimes', {
        classTimes: times.toString(),
        customerId: customerIdToUse,
        id: [currentMember.id],
        userId: user?.userId || 'U00001',
      });
      if (response.data.result === '1') {
        message.success(isReduce ? '减少课时成功' : '增加课时成功');
        setAddModalVisible(false);
        setIsReduce(false);
        setClassTimes(1);
        fetchMembers(pagination.current, pagination.pageSize);
      } else {
        message.error(isReduce ? '减少课时失败' : '增加课时失败');
      }
    } catch (error) {
      console.error('课时操作错误:', error);
      message.error(isReduce ? '减少课时失败，请稍后重试' : '增加课时失败，请稍后重试');
    }
  };

  const handleViewHistory = async (record) => {
    // 检查selectedCustomerId是否已设置
    const customerIdToUse = record.customerId || selectedCustomerId || storedUser.customerId;
    if (!customerIdToUse) {
      message.error('请选择校区');
      return;
    }
    
    setCurrentMember(record);
    setHistoryModalVisible(true);
    try {
      const response = await apiClient.get('/sports-base-server-prod/myPage/getDeductRecord', {
        params: { pageNum: 1, pageSize: 10, customerId: customerIdToUse, id: record.id }
      });
      if (response.data.result === '1') {
        setHistoryData(response.data.deductRecordList || []);
      } else {
        message.error('获取历史记录失败');
      }
    } catch (error) {
      console.error('获取历史记录错误:', error);
      message.error('获取历史记录失败，请稍后重试');
    }
  };

  // 添加列状态管理
  const [columns, setColumns] = useState([
    {
      title: '头像',
      dataIndex: 'photoAddress',
      key: 'photoAddress',
      width: 100,
      render: (photoAddress) => (
        <Image
          src={photoAddress}
          alt="会员头像"
          style={{ width: 70, height: 70, borderRadius: '50%' }}
          fallback="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IiNkZGQiLz48dGV4dCB4PSI1MCIgeT0iNTAiIGZvbnQtc2l6ZT0iMTIiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIGZpbGw9IiNmZmYiPkJhYnk8L3RleHQ+PC9zdmc+"
        />
      ),
    },
    {
      title: '姓名',
      dataIndex: 'babyName',
      key: 'babyName',
      width: 150,
      sorter: (a, b) => {
        const nameA = a.babyName || '';
        const nameB = b.babyName || '';
        return nameA.localeCompare(nameB);
      },
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="搜索姓名"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            搜索
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            重置
          </Button>
        </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) => {
        const name = record.babyName || '';
        return name.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: '性别',
      dataIndex: 'babySex',
      key: 'babySex',
      width: 100,
      sorter: (a, b) => {
        const sexA = a.babySex === '1' ? '男' : '女';
        const sexB = b.babySex === '1' ? '男' : '女';
        return sexA.localeCompare(sexB);
      },
      filters: [
        { text: '男', value: '1' },
        { text: '女', value: '0' },
      ],
      onFilter: (value, record) => record.babySex === value,
      render: (sex) => sex === '1' ? '男' : '女',
    },
    {
      title: '剩余课时',
      dataIndex: 'remainClassTimes',
      key: 'remainClassTimes',
      width: 120,
      sorter: (a, b) => {
        const timesA = parseInt(a.remainClassTimes) || 0;
        const timesB = parseInt(b.remainClassTimes) || 0;
        return timesA - timesB;
      },
      render: (times) => {
        const value = times || 0;
        let style = {};
        if (value < 20) {
          style = { color: 'red', fontWeight: 'bold', fontSize: '16px' };
        } else if (value >= 20 && value <= 30) {
          style = { color: 'blue', fontWeight: 'bold', fontSize: '16px' };
        }
        return <span style={style}>{value}</span>;
      },
    },
    {
      title: '所属小队',
      dataIndex: 'className',
      key: 'className',
      width: 150,
      sorter: (a, b) => {
        const classA = a.className || '';
        const classB = b.className || '';
        return classA.localeCompare(classB);
      },
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 250,
      render: (_, record) => (
        <div style={{ display: 'flex', gap: '4px' }}>
          <Button
            type="primary"
            size="small"
            icon={<PlusOutlined />}
            onClick={() => handleAddClassTimes(record)}
          >
            加课时
          </Button>
          <Button
            type="default"
            size="small"
            icon={<MinusOutlined />}
            onClick={() => handleReduceClassTimes(record)}
          >
            减课时
          </Button>
          <Button
            type="default"
            size="small"
            icon={<HistoryOutlined />}
            onClick={() => handleViewHistory(record)}
          >
            历史记录
          </Button>
        </div>
      ),
    }
  ]);

  const historyColumns = [
    {
      title: '剩余课时',
      dataIndex: 'remainClassTimes',
      key: 'remainClassTimes',
    },
    {
      title: '变动课时',
      dataIndex: 'classTimes',
      key: 'classTimes',
      render: (times) => {
        const value = times || 0;
        let style = {};
        if (value > 0) {
          style = { color: 'blue', fontWeight: 'bold', fontSize: '16px' };
        }
        return <span style={style}>{value}</span>;
      },
    },
    {
      title: '操作人',
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '结课时间',
      dataIndex: 'registDate',
      key: 'registDate',
    },
  ];

  return (
    <div className="menu-item-content">
      <Card title={`课时管理 (共 ${pagination.total} 条)`} style={{ margin: '16px' }}>
        <Form style={{ marginBottom: '16px' }}>
          <Row gutter={16}>
            <Col span={24}>
              <CustomerSelector 
                value={selectedCustomerId}
                onChange={(value) => {
                  setSelectedCustomerId(value);
                  setSelectedClassId('');
                }}
                onClassChange={(value) => {
                  setSelectedClassId(value);
                }}
                classList={classes}
                classIdValue={selectedClassId}
                disabled={storedUser.role !== 'R00001'}
                fetchClassList={fetchClassesByCustomerId}
              />
            </Col>
          </Row>
        </Form>
        <Spin spinning={loading}>
          <ResizableTable
            dataSource={members}
            columns={columns}
            onColumnsChange={setColumns}
            rowKey="id"
            scroll={{ x: 'max-content' }}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
              onChange: (page, size) => fetchMembers(page, size),
            }}
          />
        </Spin>
      </Card>

      <Modal
        title={isReduce ? "减课" : "加课"}
        open={addModalVisible}
        onCancel={() => { setAddModalVisible(false); setIsReduce(false); setClassTimes(1); }}
        onOk={handleConfirmAdd}
        width={400}
      >
        <Form layout="vertical">
          <Form.Item label={isReduce ? "减少课时数" : "增加课时数"}>
            <InputNumber
              min={isReduce ? -999 : 0.5}
              max={isReduce ? -0.5 : undefined}
              step={0.5}
              value={classTimes}
              onChange={(value) => setClassTimes(value)}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={`课时历史记录 - ${currentMember?.babyName}`}
        open={historyModalVisible}
        onCancel={() => setHistoryModalVisible(false)}
        footer={null}
        width={800}
      >
        <Table
          dataSource={historyData}
          columns={historyColumns}
          rowKey="registDate"
          pagination={false}
          scroll={{ y: 400 }}
        />
      </Modal>
    </div>
  );
};

export default Classperiod;
